import React from 'react';
import UniversalNavLink from '../UniversalNavLink';
import UniversalSidebarSubmenu from '../UniversalSidebar/UniversalSidebarSubmenu/UniversalSidebarSubmenu';
const OutOfAppLinks = ({ isCollapsed, navigationItems, }) => {
    return (React.createElement(React.Fragment, null, navigationItems.map((navigationItem) => {
        let itemToRender;
        if (navigationItem.variant === 'link') {
            itemToRender = (React.createElement(UniversalNavLink, { href: navigationItem.href, isCollapsed: isCollapsed, isSelected: false, isSidebar: true, text: navigationItem.text }));
        }
        if (navigationItem.variant === 'variant-a') {
            const heroAreaSubmenu = navigationItem.heroArea.submenu.map((item) => {
                return {
                    href: item.href || null,
                    text: item.text,
                };
            });
            const promoArea = {
                href: navigationItem.promoArea.header.href || null,
                text: navigationItem.promoArea.header.heading,
                submenu: navigationItem.promoArea.submenu.map((item) => {
                    return {
                        href: item.href || null,
                        text: item.tag ? `${item.text} (${item.tag})` : item.text,
                    };
                }),
            };
            const combinedSubmenus = [...heroAreaSubmenu, promoArea];
            itemToRender = (React.createElement(UniversalSidebarSubmenu, { links: combinedSubmenus, text: navigationItem.text }));
        }
        if (navigationItem.variant === 'variant-b' ||
            navigationItem.variant === 'variant-c') {
            itemToRender = (React.createElement(UniversalSidebarSubmenu, { links: navigationItem.submenu, text: navigationItem.text }));
        }
        return itemToRender ? (React.createElement("li", { key: navigationItem.text }, itemToRender)) : null;
    })));
};
export default OutOfAppLinks;
//# sourceMappingURL=OutOfAppLinks.js.map
// @zapier/universal-layout@8.6.23 (c29ded5a6)
